import {
  Box,
  Typography,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
// import { WarningAmber, Close } from "@mui/icons-material";
// import { useState } from "react";

const DisconnectModal = ({ open, onClose, onDisconnect, loading = false }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "12px",
          padding: "16px",
        },
      }}
    >
      <DialogTitle
        sx={{
          padding: 0,
          mb: 2,
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: "12px" }}>
            {/* <Box
              sx={{
                width: "48px",
                height: "48px",
                borderRadius: "50%",
                backgroundColor: "#FEE2E2",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <WarningAmber sx={{ color: "#DC2626", fontSize: "28px" }} />
            </Box> */}
            <Typography
              sx={{
                fontSize: "20px",
                fontWeight: 600,
                color: "#0F172A",
              }}
            >
              Disconnect Facebook Account
            </Typography>
          </Box>
        </Box>
      </DialogTitle>

      <DialogContent sx={{ padding: 0, mb: 3 }}>
        <DialogContentText
          sx={{
            color: "#475569",
            fontSize: "16px",
            lineHeight: 1.5,
            mb: 2,
          }}
        >
          Are you sure you want to disconnect your Facebook account from the
          platform?
        </DialogContentText>
      </DialogContent>

      <DialogActions sx={{ padding: 0, gap: "12px" }}>
        <Button
          onClick={onClose}
          variant="outlined"
          sx={{
            flex: 1,
            borderColor: "#E2E8F0",
            color: "#64748B",
            borderRadius: "8px",
            padding: "10px 16px",
            textTransform: "none",
            fontSize: "16px",
            fontWeight: 500,
            "&:hover": {
              borderColor: "#CBD5E1",
              backgroundColor: "#F8FAFC",
            },
          }}
          disabled={loading}
        >
          Cancel
        </Button>
        <Button
          onClick={onDisconnect}
          variant="contained"
          sx={{
            flex: 1,
            backgroundColor: "#f84d4dff",
            color: "#FFFFFF",
            borderRadius: "8px",
            padding: "10px 16px",
            textTransform: "none",
            fontSize: "16px",
            fontWeight: 500,
            "&:hover": {
              backgroundColor: "#f84d4dff",
            },
          }}
          disabled={loading}
        >
          {loading ? "Disconnecting..." : "Yes, Disconnect"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DisconnectModal;